module.exports = __webpack_public_path__ + "static/media/teltonika-fmb920-10.dc2a599c.png";